import React, { Component } from 'react';
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs';
import MainLayout from '../CommonControlls/MainLayout';
import Topmenu from '../CommonControlls/Topmenubar';
import { connect } from 'react-redux'
import UserImageLogo_bg from '../../images/UserImageLogo_bg.jpg'

const mapStateToProps = (store)=>{
    return store
}
  
const mapDispatchToProps = (dispatch)=>{
    return{
      ShowAlert : (Settings)=> {dispatch({type:"UpdateAlert",payload:Settings})},
      ShowLoader:(Isloading)=> {dispatch({type:"UpdateLoader",payload:Isloading})},
    }
}

class ChangePassword extends Component {

constructor(props) {
    super(props);
    this.state = {
    };
}

render(){

return(

<div>
    <MainLayout/>
    <div id="right-panel" class="right-panel">
        <Topmenu PageTitle="Change Password" isShowAddBtn={false} />              
        <div class="content">

            {/* <div class="PageHeader_Container">
                <h2>Change Password</h2>
            </div> */}

            <div class="card col-lg-4 col-md-4 col-sm-12 col-xs-12">
                <div class="card-body">
                    <form onSubmit={this.SubmitForm} novalidate>

                        <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <label for=""><span style={{color:"red"}}>* </span>Old Password</label>
                            <input autocomplete="off" type="password" class="form-control" id="OldPassword" placeholder="Enter your old password" required/>
                            <i id="OldPassword_viewlink" onClick={((e) => this.updatepasswordviewfun("OldPassword",1))} class="fa fa-eye viewpasswordicon" aria-hidden="true"></i>
                            <i id="OldPassword_hidelink" onClick={((e) => this.updatepasswordviewfun("OldPassword",2))} class="fa fa-eye-slash viewpasswordicon" style={{display:"none"}} aria-hidden="true"></i>
                        </div>

                        <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <label for=""><span style={{color:"red"}}>* </span>New Password</label>
                            <input autocomplete="off" type="password" class="form-control" id="NewPassword" placeholder="Enter new password" required/>
                            <i id="NewPassword_viewlink" onClick={((e) => this.updatepasswordviewfun("NewPassword",1))} class="fa fa-eye viewpasswordicon" aria-hidden="true"></i>
                            <i id="NewPassword_hidelink" onClick={((e) => this.updatepasswordviewfun("NewPassword",2))} class="fa fa-eye-slash viewpasswordicon" style={{display:"none"}} aria-hidden="true"></i>
                        </div>

                        <div class="form_footer formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <button type="submit" id="Form_SaveBtn" class="btn btn_style1">Save</button>
                        </div>

                    </form>               
                </div>
            </div>

        </div>
    </div>
</div>

)}

componentDidMount(){
    $(".UserTopMenu").removeClass("ActiveUserOption")
    $("#UserTopMenu_password").addClass("ActiveUserOption")
}
SubmitForm=(e)=>{

    e.preventDefault()
    this.props.ShowLoader({Isloading:true})

    var Parameters={
        oldPassword: $("#OldPassword").val(),
        newPassword: $("#NewPassword").val(),
    }
    Common.Ajax(this.props.UserAuthentication.AuthToken,"Get",false,Common.APILinks.ChangePassword,Parameters,(resp)=>{  
        this.props.ShowLoader({Isloading:false})
        if(resp.status==true)
        {
            this.props.ShowAlert({Type:1,Msg: "Saved successfully" })
            setTimeout(()=>{ $("#Alertmsgbtn").click()}, 50);
            $("#OldPassword").val("")
            $("#NewPassword").val("")
            this.updatepasswordviewfun("OldPassword",2)
            this.updatepasswordviewfun("NewPassword",2)
        }
        else
        {
            this.props.ShowAlert({Type:0,Msg:resp.message })
            setTimeout(()=>{ $("#Alertmsgbtn").click()}, 50);
        }
    },
    (error)=>{
        this.props.ShowLoader({Isloading:false})
        this.props.ShowAlert({Type:0,Msg:"Something went wronge, please try again."})
        setTimeout(()=>{ $("#Alertmsgbtn").click()}, 50); 
    }
  )
  


}
updatepasswordviewfun=(valId,type)=>{
    if(type == 1)
    {
      $("#"+ valId +"_hidelink").show()
      $("#"+ valId +"viewlink").hide()
      $("#"+valId).prop('type', 'text');
    }
    else{
      $("#"+ valId +"_hidelink").hide()
      $("#"+ valId +"viewlink").show()
      $("#"+valId).prop('type', 'password');
    }
    
}

}

export default connect( mapStateToProps , mapDispatchToProps )(ChangePassword);
